import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Typography, CircularProgress } from '@mui/material';
import {
  makeSaleMngCostData,
  makeSalesMngCostHeader,
} from '../../utils/sales_mng_cost_stats';
import CommonCostStatsTable from '../../components/common-cost-stats/CommonCostStatsTable';

//----------------------------------------------------------------------
const TotalCommonCostStatsContainer = ({ selectedYear, tableRef }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  useEffect(() => {
    if (selectedYear) {
      const headers = makeSalesMngCostHeader();
      setHeaderRows(headers);
      const tempData = makeSaleMngCostData();
      
      setData(tempData);
    }
  }, [selectedYear]);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length === 0 ? (
        <Box>
          <Typography variant="subtitle2">데이터가 없습니다.</Typography>
        </Box>
      ) : (
        <CommonCostStatsTable
          data={data}
          loading={loading}
          headerRows={headerRows}
          tableRef={tableRef}
        />
      )}
    </Box>
  );
};
//----------------------------------------------------------------------
export default TotalCommonCostStatsContainer;
